
import { ref } from '@vue/composition-api';
import { Toggle } from '05-ui-kit';
import { useContext } from '@nuxtjs/composition-api';
import type Question from '~/type/Question';
import ReviewsThumbs from '~/components/ReviewsThumbs/ReviewsThumbs.vue';
type RequestTypeLike = Awaited<ReturnType<typeof context.$api.question.like>>['result'];
type RequestTypeDislike = Awaited<ReturnType<typeof context.$api.question.dislike>>['result'];
const __sfc_main = {};
__sfc_main.props = {
  productId: {
    key: "productId",
    required: true,
    type: Number
  },
  questionId: {
    key: "questionId",
    required: true,
    type: String
  },
  comment: {
    key: "comment",
    required: true,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const context = useContext();
  const likes = ref(props.comment.like.count);
  const dislikes = ref(props.comment.dislike.count);
  const activeLike = ref(props.comment.like.active);
  const activeDislike = ref(props.comment.dislike.active);
  function onError() {
    new context.$simpleError({
      name: 'Произошла ошибка'
    });
  }
  function onClickThumbs(response: {
    [key: string]: {
      response: {
        result: RequestTypeLike | RequestTypeDislike;
      };
    };
  }, path: string) {
    likes.value = response[path].response.result.amounts.likes;
    dislikes.value = response[path].response.result.amounts.dislikes;
    activeLike.value = response[path].response.result.liked;
    activeDislike.value = response[path].response.result.disliked;
  }
  return {
    emit,
    likes,
    dislikes,
    activeLike,
    activeDislike,
    onError,
    onClickThumbs
  };
};
__sfc_main.components = Object.assign({
  Toggle,
  ReviewsThumbs
}, __sfc_main.components);
export default __sfc_main;
